var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h2',{staticClass:"center mt-12 pt-12"},[_vm._v("This page doesn't exist")])])
}]

export { render, staticRenderFns }